import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';
import { RegistrationComponent } from './registration/registration.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LocationTrackerComponent } from './location/location-tracker/location-tracker.component';
import { LoginGuard } from './login.guard';
import { AssetAuthGuard } from './guards/asset-auth.guard';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

const routes: Routes = [
  // The root startup gate renders this page, even when configuration is unavailable.
  { path: 'server-error', children: [] },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'registration', component: RegistrationComponent },
  { path: 'live', component: LocationTrackerComponent },
  {
    path: 'super-admin',
    loadChildren: () => import('./super-admin/super-admin.module').then(m => m.SuperAdminModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'super-admin' }
  },
  {
    path: 'nora',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'user' }
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'admin' }
  },
  {
    path: 'parent',
    loadChildren: () => import('./parent/parent.module').then(m => m.ParentModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'parent' }
  },
  {
    path: 'teacher',
    loadChildren: () => import('./teacher/teacher.module').then(m => m.TeacherModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'teacher' }
  },
  {
    path: 'transport',
    loadChildren: () => import('./transport/transport.module').then(m => m.TransportModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'transport' }
  },
  {
    path: 'fee-management',
    loadChildren: () => import('./fee-management/fee-management.module').then(m => m.FeeManagementModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'fee-management' }
  },
  {
    path: 'hrms',
    loadChildren: () => import('./hrms/hrms.module').then(m => m.HrmsModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'hrms' }
  },
   {
    path: 'library',
    loadChildren: () => import('./library/library.module').then(m => m.LibraryModule),
    data: { role: 'digital-assets' }
  },
  // {
  //   path: 'digital-assets',
  //   loadChildren: () => import('./digital-assets/digital-assets.module').then(m => m.DigitalAssetsModule),
  //   // canLoad: [AuthGuard],
  //   // canActivate: [AuthGuard],
  //   data: { role: 'digital-assets' }
  // },
  {
    path: 'visitor-management',
    loadChildren: () => import('./visitor-management/visitor-management.module').then(m => m.VisitorManagementModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'visitor-management' }
  },
  {
    path: 'assetmanagement',
    loadChildren: () => import('./assetmanagement/assetmanagement.module').then(m => m.AssetmanagementModule),
    // canActivate: [AssetAuthGuard],
    data: { role: 'assetmanagement' }
  },
  {
    path: 'application-tracker',
    loadChildren: () => import('./application-tracker/application-tracker.module').then(m => m.ApplicationTrackerModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'application-tracker' }
  },
   {
    path: 'parent',
    loadChildren: () => import('./parent/parent.module').then(m => m.ParentModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'parent' }
  },
   {
    path: 'store-management',
    loadChildren: () => import('./store-management/store-management.module').then(m => m.StoreManagementModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'store-management' }
  },
  {
    path: 'mis',
    loadChildren: () => import('./mis/mis.module').then(m => m.MisModule),
    // canLoad: [AuthGuard],
    // canActivate: [AuthGuard],
    data: { role: 'mis' }
  },
  { path: 'transportation', loadChildren: () => import('./admin/footer/footer.module').then(m => m.FooterModule) },
  {
    path: 'application',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
